import { Permiso_Anteriores } from './../../../models/permiso_anteriores.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-permisos-anteriores',
  templateUrl: './permisos-anteriores.component.html',
  styleUrls: ['./permisos-anteriores.component.css'],
  providers: [FormService]
})
export class PermisosAnterioresComponent {
  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

  public rows = [];
  public actualRow;
  public permiso_anteriores: Permiso_Anteriores;
  public formulario;
  public temp_permiso;
  public matcher = new FormService();

  constructor(private dialog: MatDialog) {

    this.formulario = new FormGroup({
      permiso_anterior: new FormControl(''),
      numero_anterior: new FormControl('', [Validators.pattern(/^[0-9]\d*$/)]),
      fecha_anterior: new FormControl(''),
      tipo_anterior: new FormControl(''),
      superficie_anterior: new FormControl('')
    })


    if (!JSON.parse(localStorage.getItem("permiso_anteriores"))) {
      localStorage.setItem("permiso_anteriores", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("permiso_anteriores"));

    }
    this.permiso_anteriores = { permiso_anterior: "", numero_anterior: "", fecha_anterior: "", tipo_anterior: "", superficie_anterior: "" };
    this.temp_permiso = { permiso_anterior: "", numero_anterior: "", fecha_anterior: "", tipo_anterior: "", superficie_anterior: ""  };
  }

  addPermisoAnterior() {


    this.actualRow = localStorage.getItem("permiso_anteriores");
    this.rows = JSON.parse(this.actualRow);

    if (!this.formulario.value.permiso_anterior || !this.formulario.value.numero_anterior || !this.formulario.value.fecha_anterior || !this.formulario.value.tipo_anterior || !this.formulario.value.superficie_anterior) {
      console.log("no se ingresaron datos");
      this.dialog.open(this.openModalNODATA);

    } else {
      this.rows = this.rows.concat({
        permiso_anterior: this.formulario.value.permiso_anterior,
        numero_anterior: this.formulario.value.numero_anterior,
        fecha_anterior: this.formulario.value.fecha_anterior? moment(this.formulario.value.fecha_anterior).format('DD/MM/YYYY') : "", 
        tipo_anterior: this.formulario.value.tipo_anterior,
        superficie_anterior: this.formulario.value.superficie_anterior,

      })
      localStorage.setItem("permiso_anteriores", JSON.stringify(this.rows));
      this.formulario.reset();
    }




  }

  getPermisoAnterior(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.temp_permiso.id = id;
        this.temp_permiso.permiso_anterior = this.rows[x].permiso_anterior;
        this.temp_permiso.numero_anterior = this.rows[x].numero_anterior;
        this.temp_permiso.fecha_anterior = this.rows[x].fecha_anterior;
        this.temp_permiso.tipo_anterior = this.rows[x].tipo_anterior;
        this.temp_permiso.superficie_anterior = this.rows[x].superficie_anterior;

        this.dialog.open(this.openModal);
      }
    }
  }

  cleanData() {
    this.temp_permiso =  { permiso_anterior: "", numero_anterior: "", fecha_anterior: "", tipo_anterior: "", superficie_anterior: "" };
  }

  savePermisoAnterior() {
    var id = this.temp_permiso.id;
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("permiso_anteriores", JSON.stringify(this.rows));

        $("#clasif_modal").modal("hide");
        this.actualRow = localStorage.getItem("permiso_anteriores");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
          permiso_anterior: this.temp_permiso.permiso_anterior,
          numero_anterior: this.temp_permiso.numero_anterior,
          fecha_anterior: this.temp_permiso.fecha_anterior,
          tipo_anterior: this.temp_permiso.tipo_anterior,
          superficie_anterior: this.temp_permiso.superficie_anterior,
        })
        localStorage.setItem("permiso_anteriores", JSON.stringify(this.rows));
        this.temp_permiso = { permiso_anterior: "", numero_anterior: "", fecha_anterior: "", tipo_anterior: "", superficie_anterior: "" };
        this.dialog.closeAll();
      }
    }
  }

  deletePermisoAnterior(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("permiso_anteriores", JSON.stringify(this.rows));
      }
    }
    this.actualRow = localStorage.getItem("permiso_anteriores");
    this.rows = JSON.parse(this.actualRow);
  }


}
